// @flow
import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { makeStyles } from '@material-ui/styles';
import MenuItem from '@material-ui/core/MenuItem';

import { logoutAndClean } from '../../utils/user';

const useStyles = makeStyles(theme => ({
  item: {
    paddingTop: 6,
    paddingRight: 24,
    paddingBottom: 6,
    paddingLeft: 24,
    color: theme.palette.type === 'light' ? theme.palette.ava.dark1 : theme.palette.ava.white,
    fontSize: 18,
    lineHeight: '27px',
    '&:hover': {
      background: theme.palette.type === 'light' ? theme.palette.ava.navy5 : theme.palette.ava.grey5,
    },
  },
  signout: {
    '&:hover': {
      background: theme.palette.type === 'light' ? theme.palette.ava.red5 : theme.palette.ava.red4,
    },
  },
  red: {
    color: theme.palette.ava.red2,
  },
}));

interface Props {
  className?: string;
  history: Object;
  firebaseUser: Object;
}

const SignInSignOut = ({ className, history, firebaseUser }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const onClick = async () => {
    await logoutAndClean();
    Sentry.configureScope(scope => {
      scope.setUser(null);
    });
    history.push(firebaseUser?.isAnonymous ? '/web/login' : '/web');
    window.location.reload();
  };

  return (
    <MenuItem
      className={classnames(classes.item, className, {
        [classes.signout]: !firebaseUser?.isAnonymous,
        [classes.red]: !firebaseUser?.isAnonymous,
      })}
      onClick={onClick}
    >
      {firebaseUser?.isAnonymous ? t('sidebar.signIn') : t('sidebar.signOut')}
    </MenuItem>
  );
};

const mapStateToProps = ({ firebase: { user } }) => ({ firebaseUser: user });

export default withRouter(connect(mapStateToProps)(SignInSignOut));
